import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Item } from './item.model';
import { API } from '../../shared/constants/api.constants';
import { ResponseWrapper, createRequestOption } from '../../shared';

@Injectable()
export class ItemService {
    private resourceUrlIV = API.host + 'invoices';
  
    constructor(private http: Http) { }

    private convertResponse(res: Response): any {
        if (!res || !res.json) {
            throw 'Invalid Code';
        }

        const jsonResponse = res.json().data;
        return new ResponseWrapper(res.headers, jsonResponse, res.status);
    }

    query(req?: any): Observable<ResponseWrapper> {
        
        const options = createRequestOption(req);
        return this.http.get(this.resourceUrlIV, options)
            .map((res: Response) => this.convertResponse(res));
    }
    
}
